import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useAuthService } from '@/contexts/authService';
import trackingService from '../../../state/services/tracking';
import { SEGMENT_EVENTS } from '../../../utils/tracking';

const LoginPromptOverlayContainer = ({
  noBanner,
  onlyLoggedOut,
  Component,
}) => {
  const authService = useAuthService();
  const earlyReturn =
    !Component || (onlyLoggedOut && authService.getUserCookie()) || noBanner;
  // Sends tracking event on first successful Component
  useEffect(() => {
    if (!earlyReturn) {
      trackingService.trackEvent(SEGMENT_EVENTS.BANNER_APPEARED);
    }
  }, [earlyReturn]);

  if (earlyReturn) {
    return null;
  }

  return <Component />;
};

export default LoginPromptOverlayContainer;

LoginPromptOverlayContainer.propTypes = {
  /**
   * Whether the banner should be invisible
   */
  noBanner: PropTypes.bool,
  onlyLoggedOut: PropTypes.bool,
};

LoginPromptOverlayContainer.defaultProps = {
  noBanner: false,
  onlyLoggedOut: false,
};
